'use strict';

(function () {
    'use strict';

    appRun.$inject = ['routerHelper'];
    angular.module('app.admin').run(appRun);

    function appRun(routerHelper) {
        'ngInject';

        routerHelper.configureStates(getStates());
    }

    function getStates() {
        return [{
            state: 'admin',
            config: {
                url: '/admin',
                component: 'admin'
            }
        }, {
            state: 'login',
            config: {
                url: '/admin/login',
                component: 'login'
            }
        }, {
            state: 'iot-status',
            config: {
                url: '/admin/infrastructure',
                component: 'iotStatus'
            }
        }, {
            state: 'parking',
            config: {
                url: '/admin/parking',
                component: 'parking'
            }
        }, {
            state: 'parking-historical-data',
            config: {
                url: '/admin/parking/historical-data',
                component: 'parkingHistoricalData'
            }
        }, {
            state: 'analytics-historical-data',
            config: {
                url: '/admin/analytics/historical-data',
                component: 'analyticsHistoricalData'
            }
        }, {
            state: 'gateway-status',
            config: {
                url: '/admin/gateway/:id',
                component: 'gatewayStatus',
                resolve: {
                    gateway: ['$stateParams', 'iotService', function gateway($stateParams, iotService) {
                        'ngInject';

                        return iotService.getGateway($stateParams.id, true);
                    }]
                },
                params: {
                    id: { value: undefined, squash: false }
                }
            }
        }, {
            state: 'device-status',
            config: {
                url: '/admin/device/:id',
                component: 'deviceStatus',
                resolve: {
                    device: ['$stateParams', 'iotService', function device($stateParams, iotService) {
                        'ngInject';

                        return iotService.getDevice($stateParams.id);
                    }]
                },
                params: {
                    id: { value: undefined, squash: false }
                }
            }
        }, {
            state: 'device-analytics',
            config: {
                url: '/admin/device/analytics/:id',
                component: 'deviceAnalytics',
                resolve: {
                    device: ['$stateParams', 'iotService', function device($stateParams, iotService) {
                        'ngInject';

                        return iotService.getDevice($stateParams.id);
                    }]
                },
                params: {
                    id: { value: undefined, squash: false }
                }
            }
        }];
    }
})();